import { render, staticRenderFns } from "./NameList.vue?vue&type=template&id=419d3bf4&scoped=true&"
var script = {}
import style0 from "./NameList.vue?vue&type=style&index=0&id=419d3bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419d3bf4",
  null
  
)

export default component.exports